import { 青色申告情報 } from "./taxCalcInput";

export function 青色申告特別控除額計算関数(input: 青色申告情報): number {
  // そもそも青色申告者でなければ0円
  if (!input.青色申告承認申請書を提出しているか) {
      return 0;
  }

  // 不動産所得しかない人で、それがアパート1棟など「事業的規模ではない」場合は、
  // どんなに頑張って複式簿記をつけても10万円控除になります。
  if (!input.事業所得または事業的規模の不動産所得があるか) {
      return 100000;
  }

  // 55万円・65万円のハードル（複式簿記、書類添付、期限内申告）を判定
  const 複式簿記等の要件クリア = input.複式簿記で記帳しているか && 
                                 input.貸借対照表と損益計算書を添付しているか && 
                                 input.期限内に申告しているか;

  if (複式簿記等の要件クリア) {
      // 全てクリアした上で、e-Tax等を使っていれば65万円！
      if (input.eTaxで電子申告または電子帳簿保存をしているか) {
          return 650000;
      } else {
          // 紙で提出した場合は55万円
          return 550000;
      }
  }

  // 複式簿記ではなく簡易帳簿だったり、期限を過ぎてしまった場合は10万円
  return 100000;
}